import { TFunction } from 'i18next';
import { TKeys } from './enums';

export const APP_NAME = 'Trace eye Circular Economy';

export const HTTPMethods = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
    PUT: 'PUT',
};

export const PAGINATION = {
    DEFAULT_PAGE: 1,
    LIMIT_PER_PAGE: 100,
};

export const DURATION_HIDE_ALERT: number = 60000;

export const INDEX_COLUMN_WIDTH = 60;
export const CHECKBOX_COLUMN_WIDTH = 50;
export const DEFAULT_COLUMN_WIDTH = 250;
export const DEFAULT_TITLE_SIZE = 14;
export const ICON_ACTION_COLUMN_WIDTH = 50;
export const SUB_COLUMN_WIDTH = 50;
export const COMMENT_COLUMN_WIDTH = 600;
export const JWNET_COLUMN_WIDTH = 600;
export const DATE_COLUMN_WIDTH = 200;

export const RULE = {
    LINK: /^https?:\/\//,
    FLOAT_REGEX: /^-?\d*(\.\d+)?$/,
    FLOAT_REGEX_LENGTH: /^\d{1,9}(\.\d{1,3})?$/,
};

export const TABLE_NAME = {
    USER: 'TABLE_USER',
    CONTENT: 'TABLE_CONTENT',
    TASK: 'TABLE_TASK',
    CONTAINER_CATEGORY: 'CONTAINER_CATEGORY',
    CONTAINER: 'CONTAINER',
    COMPANY: 'COMPANY',
    LOCATION: 'LOCATION',
    INSTALLATION: 'INSTALLATION',
    INSTALLATION_REGISTER: 'INSTALLATION_REGISTER',
    INSTALLATION_DETAIL: 'INSTALLATION_DETAIL',
    COLLECTION: 'COLLECTION',
    RECIVING: 'RECIVING',
    PROCESSING: 'PROCESSING',
    INVENTORY: 'INVENTORY',
    RECEIVING_DETAIL: 'RECEIVING_DETAIL',
    CONTRACT: 'CONTRACT',
    EXPORT: 'EXPORT',
    TRACES: 'TRACES',
    TASK_HISTORY: 'TASK_HISTORY',
    MASTER_HISTORY: 'MASTER_HISTORY',
    INVENTORY_PROGRESS: 'INVENTORY_PROGRESS',
    INVENTORY_PROGRESS_DETAIL: 'INVENTORY_PROGRESS_DETAIL',
    INVENTORY_PERFORMANCE: 'INVENTORY_PERFORMANCE',
    INVENTORY_PERFORMANCE_DETAIL: 'INVENTORY_PERFORMANCE_DETAIL',
    TRANSPORT: 'TRANSPORT',
    TRACKING_FORWARD: 'TRACKING_FORWARD',
    TRACKING_BACK: 'TRACKING_BACK',
    TRACKING_FORWARD_DETAIL: 'TRACKING_FORWARD_DETAIL',
    TRACKING_BACK_DETAIL: 'TRACKING_BACK_DETAIL',
    PRINT_SETTING: 'PRINT_SETTING',
    CONTAINER_COLLECTION: 'CONTAINER_COLLECTION',
    UNIT_INTEGRATION: 'UNIT_INTEGRATION',
};

export const FIELD_LENGTH = {
    min: 1,
    max: 40,
    comment: 1000,
    sensorId: 40,
    numberContainer: 99,
    TYPE_FLOAT: 9,
    password: 8,
};

export const companyTypes = (t: TFunction) => {
    return [
        {
            id: 0,
            name: t(TKeys.LBL080050),
        },
        {
            id: 1,
            name: t(TKeys.LBL120005),
        },
        {
            id: 2,
            name: t(TKeys.LBL120033),
        },
        {
            id: 3,
            name: t(TKeys.LBL080051),
        },
    ];
};

export const pagination: Pagination = {
    page: 1,
    per_page: PAGINATION.LIMIT_PER_PAGE,
    total: 0,
    total_pages: 0,
};

export const LocationType = (t: TFunction) => {
    return [
        { id: 0, name: t(TKeys.LBL040080) },
        { id: 1, name: t(TKeys.LBL040079) },
    ];
};

export const FORMAT_DATETIME = {
    YYYYMMDDHHMMSS: 'YYYY/MM/DD HH:mm:ss',
    YYYYMMDD: 'YYYY/MM/DD',
    YYYYMMDD2: 'YYYY-MM-DD',
};

export const DATA_LANGUAGE = {
    JP: {
        key: 1,
        name: 'ja',
    },
    EN: {
        key: 2,
        name: 'en',
    },
};

export const taskContainerType = (t: TFunction) => {
    return [
        { id: 0, name: t(TKeys.LBL150097) },
        { id: 1, name: t(TKeys.LBL150098) },
        { id: 2, name: t(TKeys.LBL150099) },
        { id: 3, name: t(TKeys.LBL150100) },
        { id: 4, name: t(TKeys.LBL150101) },
        { id: 5, name: t(TKeys.LBL150102) },
    ];
};

export const containerStatus = (t: TFunction) => [
    { id: 0, name: t(TKeys.LBL110093) },
    { id: 1, name: t(TKeys.LBL110094) },
    { id: 2, name: t(TKeys.LBL110095) },
    { id: 3, name: t(TKeys.LBL110096) },
    { id: 4, name: t(TKeys.LBL110097) },
    { id: 5, name: t(TKeys.LBL110098) },
    { id: 6, name: t(TKeys.LBL110099) },
    { id: 7, name: t(TKeys.LBL110100) },
    { id: 8, name: t(TKeys.LBL110101) },
    { id: 9, name: t(TKeys.LBL110102) },
    { id: 10, name: t(TKeys.LBL110103) },
    { id: 11, name: t(TKeys.LBL110104) },
];

export const PROCESSING_TASK_STATUS = {
    NOT_PROCESSED: 0,
    IN_PROGRESS: 1,
    INPUT_COMPLETED: 2,
    COMPLETED: 3,
    DELETED: 4,
} as const;

export const TYPE_PROCESSING_TASK_DETAIL = {
    PROCESSING_INPUT: 4,
    PROCESSING_OUTPUT: 5,
};

export const COLLECTION_TASK_STATUS = {
    NOT_COLLECTION: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    DELETED: 3,
};

export const PAGINATION_DEFAULT: Pagination = {
    page: PAGINATION.DEFAULT_PAGE,
    per_page: PAGINATION.LIMIT_PER_PAGE,
    total: 0,
    total_pages: 0,
};

export const MAX_IMAGE = 5;
export const MAX_QUANTITY = 99;

export const TASK_STATUS = {
    INSTALL: {
        IN_PROGRESS: 1,
        COMPLETED: 2,
    },
};

export const CONTAINER_STATUS = {
    EMPTY: 0,
    COLLECTION_REQUEST: 1,
    INSTALL_REQUEST: 2,
    RECEIVING_REQUEST: 3,
    PROCESSING_REQUEST: 4,
    TRANSPORT_REQUEST: 5,
    UNAVAILABLE: 6,
    INSTALLING: 7,
    COLLECTION_COMPLETE: 8,
    RECEIVING_COMPLETE: 9,
    PROCESSING_COMPLETE: 10,
    EXPORT_REQUEST: 11,
};

export const COMPANY_TYPE = {
    COMPANY: '0',
    DISCHARGER: '1',
    RECEVING: '2',
    TRANSPORT: '3',
    MANAGEMENT: '9',
};
export const ALl_STATUS = ['0', '1', '2', '3'];

export const FILE_NAME_DOWNLOAD = {
    TASK_HISTORY: '作業履歴',
    MASTER_HISTORY: 'マスタ履歴',
    INVENTORY_MANAGEMENT: '在庫管理',
    PROCESSING_WORK: '処理作業マスタ',
    CONTENT: '内容物マスタ',
    CONTAINER_CATEGORY: 'ユニット種別マスタ',
    USER: 'ユーザーマスタ',
    LOCATION: 'ロケーションマスタ',
    COMPANY: '企業マスタ',
    CONTAINER: 'ユニット',
    TRACE_MANAGEMENT: 'マスタ履歴',
    INVENTORY_PROGRESS: '棚卸進捗',
    INVENTORY_PERFORMANCE: '棚卸実績',
    TRACKING_FORWARD: 'トレース',
    TRACKING_BACK: 'トレース',
};

export const INVENTORY_PROGRESS_STATUS = {
    NOT_IMPLEMENT: 0, // 未実施
    IN_PROGRESS: 1, // 棚卸実施中
    COMPLETED: 2, // 棚卸完了
    DELETED: 3, // 削除済
};

export const INVENTORY_CONTAINER_STATUS = {
    IN_STOCK: 0, // 在庫あり
    OUT_OF_STOCK: 1, // 在庫なし
    WRONG_LOCATION: 2, // ロケ違い
};

export const TRACKING_STATUS = {
    INPROGRESS: 1,
    INPUT_COMPLETE: 2,
    FINAL_DISPOSAL_COMPLETED: 3,
    SECOND_CONSIGNMENT: 4,
    SECOND_CONSIGNMENT_COMPLETED: 5,
};

export const HTTP_CODE = {
    SUCCESS: 200,
    CREATE_SUCCESS: 201,
    UPDATE_SUCCESS: 202,
    DELETE_SUCCESS: 204,
    INCONSISTENT_DATA: 302,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    EXPIRED: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
    INVALID_JSON: 1000,
    SYSTEM_ERROR: 9999,
};

export const TASK_TYPE = {
    INSTALL: 0,
    COLLECT: 1,
    ARRIVAL: 2,
    MOVING: 3,
    PROCESSING: 4,
    PROCESSING_RESULT: 5,
    SHIPPING: 6,
};

export const DEFAULT_CONTENT = {
    SECOND_CONSIGNMENT: 3,
};

export const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30MB

export const THRESHOLD_COLOR = {
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
    SUCCESS: 'success',
}

export const THRESHOLD_DEFAULT = {
    temperature: 40,
    dist_level_1: 60,
    dist_level_2: 80,
    dist_level_3: 90,
}

export const CHART_TYPE = {
    TEMPERATURE: 'temperature',
    DISTANCE: 'distance'
}

export const DATA_ALERT_TYPE = {
    TEMPERATURE: 1,
    DISTANCE: 0
}

export const PERIOD_OPTIONS = (t: TFunction): { value: string; label: string, period: string }[] => [
    { value: 'day', label: t(TKeys.LBL270053), period:  t(TKeys.LBL270061) },
    { value: 'week', label: t(TKeys.LBL270054), period:  t(TKeys.LBL270062) },
    { value: 'month', label: t(TKeys.LBL270055), period:  t(TKeys.LBL270063) },
    { value: 'three_month', label: t(TKeys.LBL270056), period: '' },
];
